import { Injectable } from '@angular/core';
import { Harvest } from '../interfaces/harvest';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HarvestCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/harvests/' ;
  }

  // Create Harvest
  add(record: Harvest) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Harvest Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Harvests List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Harvest Object
  update(record: Harvest) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Harvest>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Harvest Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}